<template>
    <div class="vue-search-bar-toggle">
        <button @click="handleClick" :aria-expanded="open ? 'true' : 'false'" aria-controls="search-bar">
            {{ translations.searchText}}
        </button>
    </div>
</template>

<script>
import translations from "../mixins/translations";

export default {
    name: "SearchBarToggle",

    mixins: [translations],

    props: ['isOpen'],

    data() {
        return {
            open: this.isOpen
        }
    },

    methods: {
        handleClick() {
            this.open = ! this.open;

            this.$emit('toggle-search-bar', this.open);
        }
    },

    watch: {
        isOpen(val) {
            this.open = val;
        },
    },
}
</script>